import React, { forwardRef, useImperativeHandle, useState } from "react";
import EditTableModal from ".";

const EditTableModalWrapper = forwardRef(
  ({ setColumnConfigs, allColumns, loading, handleTableHeadings }, ref) => {
    const [show, setShow] = useState(false);
    useImperativeHandle(ref, () => ({
      open: () => {
        setShow(true);
      },
      close: () => {
        setShow(false);
      },
    }));

    return (
      <EditTableModal
        setShow={setShow}
        show={show}
        loading={loading}
        title={"Edit Table"}
        allColumns={allColumns}
        setColumnConfigs={setColumnConfigs}
      />
    );
  }
);

export default EditTableModalWrapper;
